module.exports = __webpack_public_path__ + "img/symbol_0.c9c9e84b.png";